import React, { useState, useContext, useEffect } from 'react';
import Button from 'devextreme-react/button';
import DataGrid, {
    Column, Editing, Paging, Lookup, Pager
} from 'devextreme-react/data-grid';
import './serviceStatus.css'
import { ServicesStatusSelector, getServicesStatus } from '../../store/reducers/other/servicesStatus'
import { useSelector, useDispatch } from 'react-redux'
import axiosConfig from '../../configs/axios.config';
import axios from 'axios'

const pageSizes = [25, 50, 100];
const ServicesStatus = () => {
    const dispatch = useDispatch()
    const [loadData, setLoadData] = useState({
        Id: 0,
        Name: '',
        Description: '',
        StartDate: '',
        ExpiredDate: '',
        Price: 0
    })
    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.create(axiosConfig).get('api/ServicesIT/GetServicesIT')
            setLoadData(response.data.result)
        }
        fetchData()
    }, [])

    const onRowUpdated = async (value) => {
        await axios.create(axiosConfig).post('api/ServicesIT/PostUpdateServicesIT', value.data)
    };

    const onRowRemoved = async (value) => {
        await axios.create(axiosConfig).post('api/ServicesIT/PostDelServicesIT', value.data)
    };

    const onRowInserted = async (value) => {
        await axios.create(axiosConfig).post('api/ServicesIT/PostInsertServicesIT', value.data)
        const response = await axios.create(axiosConfig).get('api/ServicesIT/GetServicesIT')
        setLoadData(response.data.result)
    };

    const onRowPrepared = (rowElement) => {
        if (rowElement.rowType === 'data' && rowElement.data) {
            if (rowElement.data.RemainingDay < 91 && rowElement.data.RemainingDay > 30)
                rowElement.rowElement.bgColor = "#FEE9CE";
            else if (rowElement.data.RemainingDay < 31)
                rowElement.rowElement.bgColor = "#F5C691";
        }

    };


    return (
        <>
            <React.Fragment>
                <DataGrid
                    id="gridContainer"
                    dataSource={loadData}
                    keyExpr="Id"
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    showBorders={true}
                    showRowLines={true}
                    onRowPrepared={onRowPrepared}
                    onRowInserted={onRowInserted}
                    onRowUpdated={onRowUpdated}
                    onRowRemoved={onRowRemoved}>

                    <Paging enabled={true} />
                    <Editing
                        mode="row"
                        allowUpdating={true}
                        allowDeleting={true}
                        allowAdding={true} />

                    <Column dataField="STT" caption="No." allowEditing={false} width={50} />
                    <Column dataField="Description" caption={"Type"} />
                    <Column dataField="Name" caption={"Description"} width={550} />
                    <Column dataField="StartDate" caption={"Started Date"} dataType="date" format={"dd/MM/yyyy"} />
                    <Column dataField="ExpiredDate" caption={"Expired Date"} dataType="date" format={"dd/MM/yyyy"} />
                    <Column dataField="Price" format={"###,###,###"} />
                    <Column dataField="RemainingDay" caption={"Remaining Day"} format={"###,###,###"} />
                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={25} />
                </DataGrid>


            </React.Fragment>
        </>
    );
};



export default ServicesStatus;